import { lazy } from 'react'
import { pageUrl } from '../services/pageUrl'

export const cash_routes = [
  // #########################################################################################
  // #############                         FLUX                    ###########################
  // #########################################################################################
  // Lot en attente

  {
    exact: true,
    path: pageUrl.cash.flow.pendingBatches,
    component: lazy(() => import('../views/menu/cash/flux/batches/table')),
  },
  // Historique des lots
  {
    exact: true,
    path: pageUrl.cash.flow.historyBatches,
    component: lazy(() =>
      import('../views/menu/cash/flux/batch-history/table/index')
    ),
  },
  {
    exact: true,
    path: '/full-calendar',
    component: lazy(() => import('../views/calendar/FullEventCalendar'))
  },
  {
    exact: true,
    path: '/advanced_search',
    component: lazy(() =>
      import('../views/menu/cash/flux/batch-history/advanced-search/index')
    ),
  },

  // integration
  {
    exact: true,
    path: pageUrl.cash.flow.importBatches,
    component: lazy(() => import('../views/menu/cash/flux/integration/index')),
  },

  // Signature pad
  {
    exact: true,
    path: pageUrl.cash.flow.signature,
    component: lazy(() =>
      import('../views/menu/cash/flux/signature-pad/index')
    ),
  },

  // Fraud monitor
  {
    exact: true,
    path: pageUrl.cash.flow.fraudMonitor,
    component: lazy(() => import('../views/menu/cash/flux/fraud-monitor')),
  },
  // Fraud monitor
  {
    exact: true,
    path: pageUrl.cash.flow.cheque,
    component: lazy(() => import('../views/menu/cash/flux/cheque')),
  },
  // Saisie
  {
    exact: true,
    path: pageUrl.cash.flow.inputBatches,
    component: lazy(() => import('../views/menu/cash/flux/entries/table')),
  },
  {
    exact: true,
    path: '/flow-entry/:flow_id/:id?',
    component: lazy(() => import('../views/menu/cash/flux/entries/fiche')),
  },
  {
    exact: true,
    path: '/entry/operation/:batch_id/new',
    component: lazy(() => import('../views/menu/cash/flux/entries/operation')),
  },
  {
    exact: true,
    path: '/entry/operation/:batch_id/edit/:remittancedetails_id',
    component: lazy(() => import('../views/menu/cash/flux/entries/operation')),
  },
  {
    exact: true,
    path: '/entry/timeline/:id',
    component: lazy(() => import('../views/menu/cash/flux/entries/timeline')),
  },

  // #########################################################################################
  // #############                         RELEVES                 ###########################
  // #########################################################################################
  // Releves de compte
  {
    exact: true,
    path: '/statement/:account_id',
    component: lazy(() =>
      import('../views/menu/cash/releves/account-statement/details/index')
    ),
  },
  {
    exact: true,
    path: pageUrl.cash.statement.list,
    component: lazy(() =>
      import('../views/menu/cash/releves/account-statement/table/index')
    ),
  },
  {
    exact: true,
    path: pageUrl.cash.statement.searchadvanched,
    component: lazy(() =>
      import(
        '../views/menu/cash/releves/account-statement/search-advance/index'
      )
    ),
  },
  {
    exact: true,
    path: pageUrl.cash.charges_banques.list,
    component: lazy(() =>
      import('../views/menu/cash/releves/charges-banques/table/index')
    ),
  },
  {
    exact: true,
    path: pageUrl.cash.agios.list,
    component: lazy(() =>
      import('../views/menu/cash/releves/agios/table/index')
    ),
  },
  // Alert Account
  {
    exact: true,
    path: pageUrl.cash.alert_account.list,
    component: lazy(() =>
      import('../views/menu/cash/releves/alertAccount/AlertReleveCompte')
    ),
  },

  // Retour traitement
  {
    exact: true,
    path: pageUrl.cash.fiche_retour.liste,
    component: lazy(() =>
      import('../views/menu/cash/releves/backFile/table/index')
    ),
  },
  // Mobilité bancaire
  {
    exact: true,
    path: pageUrl.cash.mobilityBank.liste,
    component: lazy(() =>
      import('../views/menu/cash/releves/mobilityBank/table/index')
    ),
  },
  {
    exact: true,
    path: pageUrl.cash.fiche_retour.details,
    component: lazy(() =>
      import('../views/menu/cash/releves/backFile/fiche/index')
    ),
  },

  {
    exact: true,
    path: pageUrl.cash.analyse.analyseListe,
    component: lazy(() =>
      import('../views/menu/cash/releves/analyse/table/index')
    ),
  },

  // #########################################################################################
  // #############                         TRAITEMENTS             ###########################
  // #########################################################################################
  // jobs
  {
    exact: true,
    path: pageUrl.cash.jobs.list,
    component: lazy(() => import('../views/menu/cash/traitement/jobs/table')),
  },
  {
    exact: true,
    path: pageUrl.cash.jobs.controle,
    component: lazy(() =>
      import('../views/menu/cash/traitement/sisId/table/index')
    ),
  },
  {
    exact: true,
    path: `${pageUrl.cash.jobs.controle_detail}:id`,
    component: lazy(() =>
      import('../views/menu/cash/traitement/sisId/detail/Detail')
    ),
  },
  // #########################################################################################
  // #############                         REFERENTIEL             ###########################
  // #########################################################################################
  // Company
  {
    exact: true,
    path: pageUrl.cash.repository.company,
    component: lazy(() =>
      import('../views/menu/cash/referentiel/company/table')
    ),
  },

  {
    exact: true,
    path: '/company/detail/:id',
    component: lazy(() =>
      import('../views/menu/cash/referentiel/company/fiche/New/index')
    ),
  },

  {
    exact: true,
    path: '/company/edit/:id',
    component: lazy(() =>
      import('../views/menu/cash/referentiel/company/fiche/New/index')
    ),
  },

  {
    exact: true,
    path: '/4eyes_validation/company/:request_id',
    component: lazy(() =>
      import('../views/menu/cash/referentiel/company/fiche/Validation/index')
    ),
  },
  {
    exact: true,
    path: '/company/history/:id',
    component: lazy(() =>
      import('../views/menu/cash/referentiel/company/history')
    ),
  },

  {
    exact: true,
    path: '/company/new',
    component: lazy(() =>
      import('../views/menu/cash/referentiel/company/fiche/New/index')
    ),
  },

  // Account
  {
    exact: true,
    path: pageUrl.cash.repository.account,
    component: lazy(() =>
      import('../views/menu/cash/referentiel/account/table')
    ),
  },
  {
    exact: true,
    path: '/account/detail/:id',
    component: lazy(() =>
      import('../views/menu/cash/referentiel/account/fiche/New/index')
    ),
  },
  {
    exact: true,
    path: '/account/new',
    component: lazy(() =>
      import('../views/menu/cash/referentiel/account/fiche/New/index')
    ),
  },
  {
    exact: true,
    path: '/account/edit/:id',
    component: lazy(() =>
      import('../views/menu/cash/referentiel/account/fiche/New/index')
    ),
  },

  {
    exact: true,
    path: '/account/history/:id',
    component: lazy(() =>
      import('../views/menu/cash/referentiel/account/history')
    ),
  },
  {
    exact: true,
    path: '/4eyes_validation/account/:request_id',
    component: lazy(() =>
      import('../views/menu/cash/referentiel/account/fiche/Validation/index')
    ),
  },

  // Third party group
  {
    exact: true,
    path: pageUrl.cash.repository.thirdPartyGroup,
    component: lazy(() =>
      import('../views/menu/cash/referentiel/third-party-group/table')
    ),
  },
  {
    exact: true,
    path: '/third_party_group/detail/:id',
    component: lazy(() =>
      import('../views/menu/cash/referentiel/third-party-group/fiche/index')
    ),
  },
  {
    exact: true,
    path: '/third_party_group/new',
    component: lazy(() =>
      import('../views/menu/cash/referentiel/third-party-group/fiche/index')
    ),
  },
  {
    exact: true,
    path: '/third_party_group/edit/:id',
    component: lazy(() =>
      import('../views/menu/cash/referentiel/third-party-group/fiche/index')
    ),
  },

  // Third party
  {
    exact: true,
    path: pageUrl.cash.repository.thirdParty,
    component: lazy(() =>
      import('../views/menu/cash/referentiel/third-party/table')
    ),
  },
  {
    exact: true,
    path: '/thirdparty/detail/:id',
    component: lazy(() =>
      import('../views/menu/cash/referentiel/third-party/fiche/New/index')
    ),
  },
  {
    exact: true,
    path: '/thirdparty/edit/:id',
    component: lazy(() =>
      import('../views/menu/cash/referentiel/third-party/fiche/New/index')
    ),
  },

  {
    exact: true,
    path: '/thirdparty/new',
    component: lazy(() =>
      import('../views/menu/cash/referentiel/third-party/fiche/New/index')
    ),
  },
  {
    exact: true,
    path: '/thirdparty/history/:id',
    component: lazy(() =>
      import('../views/menu/cash/referentiel/third-party/history')
    ),
  },
  {
    exact: true,
    path: '/4eyes_validation/thirdparty/:request_id',
    component: lazy(() =>
      import(
        '../views/menu/cash/referentiel/third-party/fiche/Validation/index'
      )
    ),
  },

  // Scope
  {
    exact: true,
    path: pageUrl.cash.repository.scope,
    component: lazy(() => import('../views/menu/cash/referentiel/scope/table')),
  },

  {
    exact: true,
    path: '/scope/edit/:id',
    component: lazy(() =>
      import('../views/menu/cash/referentiel/scope/fiche/New/index')
    ),
  },

  {
    exact: true,
    path: '/scope/detail/:id',
    component: lazy(() =>
      import('../views/menu/cash/referentiel/scope/fiche/New/index')
    ),
  },

  {
    exact: true,
    path: '/scope/new',
    component: lazy(() =>
      import('../views/menu/cash/referentiel/scope/fiche/New/index')
    ),
  },
  {
    exact: true,
    path: '/scope/history/:id',
    component: lazy(() =>
      import('../views/menu/cash/referentiel/scope/history')
    ),
  },
  {
    exact: true,
    path: '/4eyes_validation/scope/:request_id',
    component: lazy(() =>
      import('../views/menu/cash/referentiel/scope/fiche/Validation/index')
    ),
  },
  {
    exact: true,
    path: pageUrl.cash.repository.mandate,
    component: lazy(() =>
      import('../views/menu/cash/referentiel/mandate/table')
    ),
  },
  {
    exact: true,
    path: '/mandate/edit/:id',
    component: lazy(() =>
      import('../views/menu/cash/referentiel/mandate/fiche')
    ),
  },
  {
    exact: true,
    path: '/mandate/detail/:id',
    component: lazy(() =>
      import('../views/menu/cash/referentiel/mandate/fiche')
    ),
  },
  {
    exact: true,
    path: '/mandate/new',
    component: lazy(() =>
      import('../views/menu/cash/referentiel/mandate/fiche')
    ),
  },

  // Timeline
  {
    exact: true,
    path: pageUrl.cash.repository.timeLine,
    component: lazy(() =>
      import('../views/menu/cash/referentiel/timeline/table')
    ),
  },
  {
    exact: true,
    path: '/timeline/edit/:id',
    component: lazy(() =>
      import('../views/menu/cash/referentiel/timeline/fiche/index')
    ),
  },
  {
    exact: true,
    path: '/timeline/detail/:id',
    component: lazy(() =>
      import('../views/menu/cash/referentiel/timeline/fiche/index')
    ),
  },
  {
    exact: true,
    path: '/timeline/new',
    component: lazy(() =>
      import('../views/menu/cash/referentiel/timeline/fiche/index')
    ),
  },

  // #########################################################################################
  // #############                         PARAMETRAGE             ###########################
  // #########################################################################################
  // Filiale User
  {
    exact: true,
    path: pageUrl.cash.settings.user,
    component: lazy(() =>
      import('../views/menu/cash/parametrage/filialeusers/table')
    ),
  },
  {
    exact: true,
    path: '/entity_user/new',
    component: lazy(() =>
      import('../views/menu/cash/parametrage/filialeusers/fiche/index')
    ),
  },
  {
    exact: true,
    path: '/entity_user/edit/:id',
    component: lazy(() =>
      import('../views/menu/cash/parametrage/filialeusers/fiche/index')
    ),
  },
  {
    exact: true,
    path: '/entity_user/detail/:id',
    component: lazy(() =>
      import('../views/menu/cash/parametrage/filialeusers/fiche/index')
    ),
  },
  // Groupe User
  {
    exact: true,
    path: pageUrl.cash.settings.userGroup,
    component: lazy(() =>
      import('../views/menu/cash/parametrage/groupusers/table')
    ),
  },
  {
    exact: true,
    path: '/user_profile/new',
    component: lazy(() =>
      import('../views/menu/cash/parametrage/groupusers/fiche/New/index')
    ),
  },


  {
    exact: true,
    path: '/user_profile/edit/:id',
    component: lazy(() =>
      import('../views/menu/cash/parametrage/groupusers/fiche/New/index')
    ),
  },
  {
    exact: true,
    path: '/user_profile/history/:id',
    component: lazy(() =>
      import('../views/menu/cash/parametrage/groupusers/history')
    ),
  },
  {
    exact: true,
    path: '/4eyes_validation/user_profile/:request_id',
    component: lazy(() =>
      import('../views/menu/cash/parametrage/groupusers/fiche/Validation/index')
    ),
  },

  // Abonnement aux smart tags
  {
    exact: true,
    path: pageUrl.cash.settings.SmartTagSubscription,
    component: lazy(() =>
      import('../views/menu/cash/parametrage/smart-tags/table')
    ),
  },

  {
    exact: true,
    path: '/smart-tags/new',
    component: lazy(() =>
      import(
        '../views/menu/cash/parametrage/smart-tags/create-edit-smart-tags/index'
      )
    ),
  },
  {
    exact: true,
    path: '/smart-tags/edit/:id',
    component: lazy(() =>
      import(
        '../views/menu/cash/parametrage/smart-tags/create-edit-smart-tags/index'
      )
    ),
  },

  // Validation 4 Yeux
  {
    exact: true,
    path: pageUrl.cash.settings.eyes,
    component: lazy(() => import('../views/menu/cash/parametrage/4eyes')),
  },

  // collège
  {
    exact: true,
    path: pageUrl.cash.settings.college,
    component: lazy(() =>
      import('../views/menu/cash/parametrage/college/table')
    ),
  },
  {
    exact: true,
    path: '/college/new',
    component: lazy(() =>
      import('../views/menu/cash/parametrage/college/fiche/New/index')
    ),
  },
  {
    exact: true,
    path: '/college/edit/:id',
    component: lazy(() =>
      import('../views/menu/cash/parametrage/college/fiche/New/index')
    ),
  },
  {
    exact: true,
    path: '/college/history/:id',
    component: lazy(() =>
      import('../views/menu/cash/parametrage/college/history')
    ),
  },
  {
    exact: true,
    path: '/4eyes_validation/college/:request_id',
    component: lazy(() =>
      import('../views/menu/cash/parametrage/college/fiche/Validation/index')
    ),
  },
  // Pouvoirs de signatures
  {
    exact: true,
    path: pageUrl.cash.settings.authority,
    component: lazy(() =>
      import('../views/menu/cash/parametrage/authority/table')
    ),
  },

  {
    exact: true,
    path: '/signing_authority/edit/:id',
    component: lazy(() =>
      import('../views/menu/cash/parametrage/authority/fiche/New/index')
    ),
  },
  {
    exact: true,
    path: '/signing_authority/new',
    component: lazy(() =>
      import('../views/menu/cash/parametrage/authority/fiche/New/index')
    ),
  },
  {
    exact: true,
    path: '/authority/history/:id',
    component: lazy(() =>
      import('../views/menu/cash/parametrage/authority/history')
    ),
  },
  {
    exact: true,
    path: '/4eyes_validation/pouvoir/:request_id',
    component: lazy(() =>
      import('../views/menu/cash/parametrage/authority/fiche/Validation/index')
    ),
  },
  // #########################################################################################
  // #############                         COMPTABILITE            ###########################
  // #########################################################################################
  {
    exact: true,
    path: pageUrl.cash.accounting.rules,
    component: lazy(() =>
      import('../views/menu/cash/comptabilite/rules/table/index')
    ),
  },

  {
    exact: true,
    path: '/compta_rules/detail/:id',
    component: lazy(() =>
      import('../views/menu/cash/comptabilite/rules/fiche')
    ),
  },
  {
    exact: true,
    path: '/compta_rules/edit/:id',
    component: lazy(() =>
      import('../views/menu/cash/comptabilite/rules/fiche')
    ),
  },
  {
    exact: true,
    path: '/compta_rules/new',
    component: lazy(() =>
      import('../views/menu/cash/comptabilite/rules/fiche')
    ),
  },
  {
    exact: true,
    path: pageUrl.cash.accounting.entry,
    component: lazy(() =>
      import('../views/menu/cash/comptabilite/writing/table/index')
    ),
  },
  {
    exact: true,
    path: '/create_frm_ecritures',
    component: lazy(() =>
      import(
        '../views/menu/cash/comptabilite/writing/create-edit-writing/index'
      )
    ),
  },
  {
    exact: true,
    path: '/frm_Ecritures/visualisation_session',
    component: lazy(() =>
      import(
        '../views/menu/cash/comptabilite/writing/visuSession/index'
      )
    ),
  },
  {
    exact: true,
    path: '/frm_ecritures/edit/:id',
    component: lazy(() =>
      import(
        '../views/menu/cash/comptabilite/writing/create-edit-writing/index'
      )
    ),
  },
  {
    exact: true,
    path: pageUrl.cash.accounting.reconciliation,
    component: lazy(() =>
      import('../views/menu/cash/comptabilite/rapprochement/table/index')
    ),
  },
  {
    exact: true,
    path: '/frm_rappro_details',
    component: lazy(() =>
      import(
        '../views/menu/cash/comptabilite/rapprochement/reconciliation/index'
      )
    ),
  },
  {
    exact: true,
    path: pageUrl.cash.accounting.consultation,
    component: lazy(() =>
      import('../views/menu/cash/comptabilite/consultation/table/index')
    ),
  },
  // historique
  {
    exact: true,
    path: pageUrl.cash.accounting.history,
    component: lazy(() =>
      import('../views/menu/cash/comptabilite/historique/table')
    ),
  },
  {
    exact: true,
    path: '/accounting/rappro-histo/details',
    component: lazy(() =>
      import('../views/menu/cash/comptabilite/historique/details')
    ),
  },
  {
    exact: true,
    path: '/accounting/consultation/initialisation',
    component: lazy(() =>
      import('../views/menu/cash/comptabilite/consultation/detail')
    ),
  },

  {
    exact: true,
    path: pageUrl.cash.accounting.closing,
    component: lazy(() =>
      import('../views/menu/cash/comptabilite/cloture/table/index')
    ),
  },

  {
    exact: true,
    path: pageUrl.cash.accounting.movement,
    component: lazy(() =>
      import('../views/menu/cash/comptabilite/movement/table/index')
    ),
  },

  // #########################################################################################
  // #############                         EXPORT COMPTABLE        ###########################
  // #########################################################################################
  {
    exact: true,
    path: pageUrl.cash.accountingExport.rule,
    component: lazy(() =>
      import('../views/menu/cash/export_comptable/rules/table/index')
    ),
  },
  {
    exact: true,
    path: '/generation_rules/new',
    component: lazy(() =>
      import('../views/menu/cash/export_comptable/rules/fiche/index')
    ),
  },
  {
    exact: true,
    path: '/generation_rules/edit/:id',
    component: lazy(() =>
      import('../views/menu/cash/export_comptable/rules/fiche/index')
    ),
  },

  {
    exact: true,
    path: pageUrl.cash.accountingExport.interface,
    component: lazy(() =>
      import('../views/menu/cash/export_comptable/interfaces/table/index')
    ),
  },
  {
    exact: true,
    path: '/generation_interface/new',
    component: lazy(() =>
      import('../views/menu/cash/export_comptable/interfaces/fiche/index')
    ),
  },
  {
    exact: true,
    path: '/generation_interface/edit/:id',
    component: lazy(() =>
      import('../views/menu/cash/export_comptable/interfaces/fiche/index')
    ),
  },

  {
    exact: true,
    path: pageUrl.cash.accountingExport.fog,
    component: lazy(() =>
      import('../views/menu/cash/export_comptable/brouillard/table/index')
    ),
  },
  {
    exact: true,
    path: '/brouillard_details',
    component: lazy(() =>
      import('../views/menu/cash/export_comptable/brouillard/details/index')
    ),
  },

  // #########################################################################################
  // #############                        TAUX ET DEVISE            ###########################
  // #########################################################################################

  {
    exact: true,
    path: pageUrl.cash.rateAndCurrency.rate,
    component: lazy(() =>
      import('../views/menu/cash/currenciesandrates/rates/table/index')
    ),
  },
  {
    exact: true,
    path: '/rate/detail/:id',
    component: lazy(() =>
      import('../views/menu/cash/currenciesandrates/rates/detail/index')
    ),
  },
  {
    exact: true,
    path: pageUrl.cash.rateAndCurrency.currency,
    component: lazy(() =>
      import('../views/menu/cash/currenciesandrates/currencies/table/index')
    ),
  },
  {
    exact: true,
    path: '/currency/detail/:id',
    component: lazy(() =>
      import('../views/menu/cash/currenciesandrates/currencies/detail/index')
    ),
  },
  // Analyse
  {
    exact: true,
    path: pageUrl.cash.analyseFlux.liste,
    component: lazy(() =>
      import('../views/menu/cash/flux/analyse/table/index')
    ),
  },
]

